'use strict'
import {DES} from 'crypto-js'
import Utf8 from 'crypto-js/enc-utf8'
import ECB from 'crypto-js/mode-ecb'
import Pkcs7 from 'crypto-js/pad-pkcs7'

export default {
  install(Vue, options) {
    Vue.prototype.$fixSelectTop = function (data) {
      if (!JSON.parse(localStorage.getItem('isNoScale'))) {
        let clientScale = document.documentElement.clientWidth / 3840
        let timeout = setTimeout(() => {
          for (let index = 0; index < document.getElementsByClassName('ivu-select-dropdown').length; index++) {
            document.getElementsByClassName('ivu-select-dropdown')[index].style.top = (document.getElementsByClassName('ivu-select-dropdown')[index].style.top.replace('px', '') / clientScale) + 'px'
          }
          clearTimeout(timeout)
        }, 60)
      }
    }
  }
}

export const valueEncode = (val) => DES.encrypt(
  val,
  Utf8.parse('Drv6RmWiL25ZAX48dOo5GJ8qDaPq9OaH'),
  {mode: ECB, padding: Pkcs7}
).toString()

export const validCodeEncode = (val, random) => valueEncode(`123456_${random}_${val}`)



// WEBPACK FOOTER //
// ./src/util/fun.js